module.exports = __webpack_public_path__ + "img/logo2.0ce7fde1.svg";